import React, {useState, useRef, useEffect} from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { renderHeaderEditor } from '../../../helpers/editorToolbar';
import { Editor } from 'primereact/editor';
import performanceService from '../../../services/data/performance.service';
import companyService from '../../../services/data/company.service';
import { Dropdown } from 'primereact/dropdown';



export default function FormCreateDevPlanQuestion(props) {
    
    const toast = useRef(null);
    const headerEditor = renderHeaderEditor();
    const [objId, setObjId] = useState('')
    const [question, setQuestion] = useState('')
    const [templateId, setTemplateID] = useState('') // performance template
    const [competenciesList, setCompetenciesList] = useState('')
    const [competency, setCompetency] = useState(null)

    useEffect(() => {
        if(props.obj) {
            setObjId(props.obj.id)
            setQuestion(props.obj.question)
            if (props.obj.competency) {
                setCompetency(props.obj.competency.competency_id)
            } else {
                setCompetency(null)
            }
        }
    }, [props.obj])

    useEffect(() => {
        if (props.templateId) {
            setTemplateID(props.templateId)
        }
    }, [props.templateId])


    useEffect(() => {
        listCompetencies()
    }, [])

    const listCompetencies = () => {
        companyService.listCompetencies().then((response) => {
            let pList = response.results.map((item) => {
                return {
                    name: item.title,
                    code: item.id
                }
            })
            setCompetenciesList(pList)
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            question: question || '',
            competency: competency || null
        },
       
        onSubmit: values => {

            let data = {
                company_id: localStorage.getItem("companyId"),
                question: values.question
            }

            if (props.assessment) {
                data.assessment_id = props.assessment
            }

            if (props.session) {
                data.session_id = props.session
            }

            if (values.competency) {
                data.competency_id = values.competency
            }

            if (props.obj?.competency?.question_competency_id) {
                data.question_competency_id = props.obj.competency.question_competency_id
            }

            if (props.employee) {
                data.employee_id = props.employee
            }

            if (objId) {

                data.id = objId

                performanceService.updateAssessmentQuestion(data).then(() => {
    
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Pergunta atualizada com sucesso', life: 3000 });

                    if (props.listItems) {
                        props.listItems()
                    }
    
                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data[0], life: 4000 });
                }).finally(() => {
                    setCompetency(null)
                });

            } else {

                if (templateId) {
                    data.template = true
                }

                performanceService.createAssessmentQuestion(data).then((response) => {
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Pergunta criada com sucesso', life: 3000 });
                    
                    if (templateId) {
                        //add question to performance template
                        let dataTemp = {
                            company_id: localStorage.getItem("companyId"),
                            questions: [response.question],
                            id: templateId
                        }
                        if (props.session) {
                            dataTemp.session_id = props.session
                        }
                        performanceService.updatePerformanceTemplateContent(dataTemp)
                    }

                    if (props.listItems) {
                        props.listItems()
                    }

                    // Reset form and local state after successful creation
                    formik.resetForm()
                    setQuestion('')
                    setCompetency(null)
                    setObjId('')

                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data[0], life: 4000 });
                });
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <Toast ref={toast} position="top-right" />

            <div className="my-3">
                <label className="form-label fw-bold">Objetivo a Desenvolver <span className="text-danger">*</span></label>
                <Editor
                    name="question"
                    style={{ height: '120px' }}
                    headerTemplate={headerEditor}
                    value={formik.values.question}
                    onTextChange={(e) => {
                        formik.setFieldValue('question', e.htmlValue);
                    }}
                />
            </div>

            <div className='my-3'>
                <label className="form-label fw-bold">Objetivo relacionado a alguma competência?</label>
                <div className='p-inputgroup'>
                    <Dropdown showClear filter name='competency' placeholder="Selecionar" value={formik.values.competency} optionLabel="name" optionValue="code" options={competenciesList} onChange={(e) => {
                        formik.setFieldValue('competency', e.value);
                    }} className="rounded" />
                </div>
            </div>
            
            <div className="d-grid mx-auto btnMargin">
                <button className="btn btn-success btn-sm btn-rounded" type="submit">
                {
                    objId ?
                    <>Atualizar</>
                    :
                    <>Adicionar</>
                }
                </button>
            </div>
        </form>
    )
}